import { useState } from "react";
import { toast } from "sonner";
import { Textarea } from "@/components/ui/textarea";
import { Panel } from "@/components/admin/Panel";
import { api, fmtDate, formatErr } from "@/lib/api";

export const NotesPanel = ({ app, onChange }) => {
  const [text, setText] = useState("");
  const add = async () => {
    if (!text.trim()) return;
    try {
      await api.post(`/admin/applications/${app.id}/notes`, { text });
      setText("");
      onChange();
    } catch (e) {
      toast.error(formatErr(e));
    }
  };
  return (
    <Panel title="Internal notes" testId="panel-notes">
      <div className="space-y-3 max-h-72 overflow-y-auto mb-4">
        {app.notes.length === 0 && <p className="text-sm text-muted-foreground">No notes yet.</p>}
        {[...app.notes].reverse().map((n) => (
          <div key={n.id} className="rounded-xl bg-secondary p-3 text-sm" data-testid={`note-${n.id}`}>
            <p className="whitespace-pre-wrap">{n.text}</p>
            <p className="mt-1 text-xs text-muted-foreground">{n.author} · {fmtDate(n.at)}</p>
          </div>
        ))}
      </div>
      <Textarea rows={3} placeholder="Add a private note (admins only)" value={text} onChange={(e) => setText(e.target.value)} className="rounded-xl" data-testid="note-input" />
      <button onClick={add} className="mt-3 h-10 px-5 rounded-full bg-primary text-primary-foreground text-sm font-bold" data-testid="note-add-button">Add note</button>
    </Panel>
  );
};

export const HistoryPanel = ({ app }) => (
  <Panel title="Status history" testId="panel-history">
    <ol className="relative border-l-2 border-border ml-2 space-y-4">
      {app.history.map((h, i) => (
        <li key={i} className="ml-4">
          <span className="absolute -left-[7px] mt-1.5 h-3 w-3 rounded-full bg-primary" />
          <p className="text-sm font-bold">{h.status}</p>
          <p className="text-xs text-muted-foreground">{fmtDate(h.at)} · {h.by}</p>
        </li>
      ))}
    </ol>
  </Panel>
);
